import React, { useState } from 'react';
import { getSeasonForDate } from '../../utils/seasonUtils';
import '../../assets/scss/seasonalCalendar.scss';

const SeasonalCalendarView = ({ seasonalDates, selectedYear, onYearChange }) => {
    const [currentYear, setCurrentYear] = useState(selectedYear || new Date().getFullYear());

    const months = [
        'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
        'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
    ];

    const seasonColors = {
        lowSeason: '#28a745',
        midSeason: '#ffc107',
        highSeason: '#dc3545',
        default: '#e9ecef'
    };

    const seasonLabels = {
        lowSeason: 'Basse Saison',
        midSeason: 'Moyenne Saison',
        highSeason: 'Haute Saison'
    };

    // Get number of days in a month
    const getDaysInMonth = (year, month) => {
        return new Date(year, month, 0).getDate();
    };

    // Get first day of week for a month (0 = Sunday, 1 = Monday, etc.)
    const getFirstDayOfMonth = (year, month) => {
        const firstDay = new Date(year, month - 1, 1).getDay();
        return firstDay === 0 ? 6 : firstDay - 1; // Convert to Monday = 0 format
    };

    // Generate calendar for a specific month
    const generateMonthCalendar = (monthIndex) => {
        const month = monthIndex + 1; // Convert to 1-12
        const daysInMonth = getDaysInMonth(currentYear, month);
        const firstDay = getFirstDayOfMonth(currentYear, month);

        const days = [];

        // Add empty cells for days before month starts
        for (let i = 0; i < firstDay; i++) {
            days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
        }

        // Add actual days
        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(currentYear, monthIndex, day);
            const season = getSeasonForDate(date, seasonalDates);
            const colorClass = season ? `season-${season}` : 'season-default';

            days.push(
                <div key={day} className={`calendar-day ${colorClass}`} title={season ? seasonLabels[season] : 'Aucune saison définie'}>
                    {day}
                </div>
            );
        }

        return days;
    };

    // Handle year navigation
    const handleYearChange = (newYear) => {
        setCurrentYear(newYear);
        if (onYearChange) {
            onYearChange(newYear);
        }
    };

    // Group months into rows of 3
    const monthRows = [];
    for (let i = 0; i < 12; i += 3) {
        monthRows.push(months.slice(i, i + 3));
    }

    return (
        <div className="seasonal-calendar-view">
            <div className="calendar-header">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="blue fw-bold mb-0">Aperçu Annuel des Saisons</h3>

                    {/* Year Navigation */}
                    <div className="year-navigation d-flex align-items-center gap-2">
                        <button
                            type="button"
                            onClick={() => handleYearChange(currentYear - 1)}
                            className="btn btn-sm btn-outline-secondary"
                        >
                            ←
                        </button>
                        <span className="fw-bold fs-5">{currentYear}</span>
                        <button
                            type="button"
                            onClick={() => handleYearChange(currentYear + 1)}
                            className="btn btn-sm btn-outline-secondary"
                        >
                            →
                        </button>
                    </div>
                </div>

                <div className="legend">
                    <div className="legend-item">
                        <div className="legend-color season-lowSeason"></div>
                        <span>Basse Saison</span>
                    </div>
                    <div className="legend-item">
                        <div className="legend-color season-midSeason"></div>
                        <span>Moyenne Saison</span>
                    </div>
                    <div className="legend-item">
                        <div className="legend-color season-highSeason"></div>
                        <span>Haute Saison</span>
                    </div>
                    <div className="legend-item">
                        <div className="legend-color season-default"></div>
                        <span>Non défini</span>
                    </div>
                </div>
            </div>

            <div className="year-calendar">
                {monthRows.map((monthRow, rowIndex) => (
                    <div key={rowIndex} className="month-row">
                        {monthRow.map((monthName, colIndex) => {
                            const monthIndex = rowIndex * 3 + colIndex;
                            return (
                                <div key={monthName} className="month-container">
                                    <div className="month-header">
                                        <h4>{monthName} {currentYear}</h4>
                                    </div>
                                    <div className="month-calendar">
                                        <div className="weekdays">
                                            <div>L</div>
                                            <div>M</div>
                                            <div>M</div>
                                            <div>J</div>
                                            <div>V</div>
                                            <div>S</div>
                                            <div>D</div>
                                        </div>
                                        <div className="days-grid">
                                            {generateMonthCalendar(monthIndex)}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SeasonalCalendarView; 